module.exports = __webpack_public_path__ + "img/FR19063.0e067708.png";